// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorCoverageMedicalCoverageMedicalCoverageResponse {
    static getAttributeTypeMap() {
        return PayorCoverageMedicalCoverageMedicalCoverageResponse.attributeTypeMap;
    }
}
PayorCoverageMedicalCoverageMedicalCoverageResponse.discriminator = undefined;
PayorCoverageMedicalCoverageMedicalCoverageResponse.additionalProperties = false;
PayorCoverageMedicalCoverageMedicalCoverageResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PayorAccountMedicalCoverageModels"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payorCoverageMedicalCoverageMedicalCoverageResponse.js.map